<template>
  <div class="global-content-box global-content-flex">
    <y-back-action
      :title="['会员总览']"
      subTitle="导入记录"
      @back="closePage"
    />
    <!-- 顶部搜索区域 -->
    <div class="activityWrapper">
      <y-form :form-info="formInfo" @search="hugItemSearch"></y-form>
    </div>
    <!-- 切换导航栏 -->
    <el-tabs v-model="topSelect" @tab-click="hugItemBtn">
      <el-tab-pane label="会员" name="1"></el-tab-pane>
      <el-tab-pane label="积分" name="2"></el-tab-pane>
    </el-tabs>
    <!-- 表格 -->
    <div class="global-felx-1">
      <y-table
        :tableData="tableData"
        tooltip-effect="dark"
        :loading="talbeLoading"
        :tableInfo="tableInfo"
        :pageInfo="{
          pageNum: formDataList.pageNum,
          pageSize: formDataList.pageSize,
          total: totalList,
        }"
        @handlePage="handlePage"
      >
        <template #edit="scope">
          <div @click="openRecordDialog(scope.row)" class="displayItem">
            <img
              class="down-icon"
              src="@/assets/images/memberAll/down.png"
              alt
            />
          </div>
        </template>
      </y-table>
    </div>
    <!-- 身份验证弹窗 -->
    <authentication-dialog
      @goBack="sendDialog = false"
      v-if="sendDialog"
      :sendType="sendType"
      :sendDialog="sendDialog"
      :phone="phone"
      @sureExport="sureExport"
    ></authentication-dialog>
  </div>
</template>

<script>
import authenticationDialog from "@/components/authentication-dialog";
import { getChannelSellerInfo } from "@/api/channelCommonController";
import {
  getUploadFileRecord,
  getMemberUploadRecord,
  exportExcelURL,
} from "@/api/memberMessageSystem";
export default {
  name: "importRecords",
  components: {
    authenticationDialog,
  },
  data() {
    return {
      topSelect: "1",
      formDataList: {
        fileName: "",
        uploadState: "", //状态 0:未处理 1:处理中 2:处理完成 3:导入失败
        uploadStartTime: "", //首次入会时间-开始
        uploadEndTime: "", //首次入会时间-截止
        pageNum: 1,
        pageSize: 10,
        scoresCardId: "",
      },
      importTypeList: [
        {
          value: "",
          label: "不限",
        },
        {
          value: 0,
          label: "未处理",
        },
        {
          value: 1,
          label: "处理中",
        },
        {
          value: 2,
          label: "处理完成",
        },
        {
          value: 3,
          label: "导入失败",
        },
      ],
      talbeLoading: false,
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.formDataList.endTime) {
            return (
              time.getTime() > new Date(this.formDataList.endTime).getTime()
            );
          } else {
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.formDataList.startTime) {
            return (
              time.getTime() < new Date(this.formDataList.startTime).getTime()
            );
          } else {
          }
        },
      },
      totalList: 0,
      tableData: [],
      // 导出弹窗及相关的身份验证
      sendDialog: false, //短信验证弹窗
      phone: "", //用户的手机号
      sendType: 3, //到时候看后端接口哪个类型  3代表会员，7代表积分
      fileId: "",

      formInfo: [
        {
          label: "文件名称：",
          prop: "fileName",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "导入状态：",
          prop: "uploadState",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            {
              value: "",
              label: "不限",
            },
            {
              value: 0,
              label: "未处理",
            },
            {
              value: 1,
              label: "处理中",
            },
            {
              value: 2,
              label: "处理完成",
            },
            {
              value: 3,
              label: "导入失败",
            },
          ],
        },
        {
          label: "导入时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "uploadStartTime",
          endKey: "uploadEndTime",
        },
      ],
      tableInfo: [
        {
          prop: "fileName",
          label: "文件名称",
        },
        {
          prop: "uploadTime",
          label: "导入时间",
        },
        {
          prop: "recordCount",
          label: "文件记录数",
          align: "right",
        },
        {
          prop: "successCount",
          label: "成功导入数",
          align: "right",
        },
        {
          prop: "failCount",
          label: "导入失败数",
          align: "right",
        },
        {
          prop: "platform",
          label: "买家所在平台",
          // 平台来源 1:淘宝 2:京东 3:有赞 4:微信 5:抖音 6:快手
          formatter: (row) => {
            if (row.platform == 1) {
              return "淘宝";
            } else if (row.platform == 2) {
              return "京东";
            } else if (row.platform == 3) {
              return "有赞";
            } else if (row.platform == 4) {
              return "微信";
            } else if (row.platform == 5) {
              return "抖音";
            } else if (row.platform == 6) {
              return "快手";
            } else {
              return "-";
            }
          },
        },
        {
          prop: "finishTime",
          label: "处理完成时间",
        },
        {
          prop: "uploadState",
          label: "状态",
          // 状态 0:未处理 1:处理中 2:处理完成 3:导入失败
          formatter: (row) => {
            if (row.uploadState == 1) {
              return "处理中";
            } else if (row.uploadState == 2) {
              return "处理完成";
            } else if (row.uploadState == 3) {
              return "导入失败";
            } else {
              return "未处理";
            }
          },
        },
        {
          prop: "edit",
          label: "操作",
          slot: "edit",
        },
      ],
    };
  },
  created() {
    // 获取当前会员体系详情
    this.MemberSystemInfo = this.$store.state.MemberSystemInfo;
    console.log("this.MemberSystemInfo", this.MemberSystemInfo);
  },
  mounted() {
    this.formDataList.scoresCardId = this.MemberSystemInfo.scoresCardId;
    this.getSellerInfo(); // 获取商家信息
    this.getMeberList(); //获取会员列表
  },
  methods: {
    // 获取积分列表
    getPointList() {
      this.talbeLoading = true;
      getUploadFileRecord(this.formDataList).then((res) => {
        this.talbeLoading = false;
        if (res.code == 200) {
          this.tableData = res.data.dataList;
          this.totalList = res.data.pageInfo.total;
        }
      });
    },
    getMeberList() {
      this.talbeLoading = true;
      getMemberUploadRecord(this.formDataList).then((res) => {
        this.talbeLoading = false;
        if (res.code == 200) {
          this.tableData = res.data.dataList;
          this.totalList = res.data.pageInfo.total;
        }
      });
    },
    getClean() {
      this.formDataList = {
        scoresCardId: this.MemberSystemInfo.scoresCardId,
        fileName: "",
        uploadState: "",
        uploadStartTime: "", //首次入会时间-开始
        uploadEndTime: "", //首次入会时间-截止
        pageNum: 1,
        pageSize: 10,
      };
      this.hugItemBtn();
    },
    handlePage(page) {
      this.formDataList.pageNum = page.pageNum;
      this.formDataList.pageSize = page.pageSize;
      // this.hugItemBtn();
      if (this.topSelect == "2") {
        this.getPointList();
        this.sendType = 7;
      } else {
        this.getMeberList();
        this.sendType = 3;
      }
    },
    closePage() {
      this.$emit("close");
    },
    hugItemSearch(obj) {
      for (const key in obj) {
        this.formDataList[key] = obj[key];
      }
      this.formDataList.pageNum = 1;
      // this.hugItemBtn();
      if (this.topSelect == "2") {
        this.getPointList();
        this.sendType = 7;
      } else {
        this.getMeberList();
        this.sendType = 3;
      }
    },
    //点击切换
    hugItemBtn() {
      this.formDataList.pageNum = 1;
      if (this.topSelect == "2") {
        // 3代表会员，7代表积分
        // 积分
        this.getPointList();
        this.sendType = 7;
      } else {
        //会员
        this.getMeberList();
        this.sendType = 3;
      }
    },
    // 获取商家信息
    getSellerInfo() {
      getChannelSellerInfo().then((res) => {
        if (res.code == 200) {
          console.log(res);
          this.phone = res.data.mobile;
        }
      });
    },
    //打开手机验证
    openSendDialog(item) {
      this.sendDialog = true;
    },
    openRecordDialog(item) {
      this.sendDialog = true;
      if (this.topSelect == "1") {
        //会员
        this.fileId = item.sellerUploadFileId;
      } else {
        //积分
        this.fileId = item.scoresSellerUploadFileId;
      }
    },
    // 导出接口
    sureExport(val) {
      console.log(val);
      var code = val.vcode;
      let _type = 3;

      if (this.topSelect == "1") {
        //会员
        _type = 3;
      } else {
        //积分
        _type = 7;
      }
      let param = {
        code: code,
        type: _type,
        id: this.fileId,
      };
      exportExcelURL(param)
        .then((res) => {
          if (res.code == 200) {
            let url = res.data;
            console.log("url", url);
            let fileName = "导入记录文件数.xls";
            let elem = document.createElement("a");
            elem.style.display = "none";
            elem.href = url;
            elem.setAttribute("download", fileName);
            document.body.appendChild(elem);
            elem.click();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {});
      this.sendDialog = false;
    },

    clearTimeSendTime() {
      (this.formDataList.uploadStartTime = ""),
        (this.formDataList.uploadEndTime = "");
    },
  },
};
</script>

<style lang="scss" scoped>
.displayItem {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.activityWrapper {
  box-sizing: border-box;
  margin-bottom: 16px;
  margin-top: 16px;
}
.down-icon {
  width: 16px;
  cursor: pointer;
}
</style>